import React from 'react'
import useAxios from 'hooks/useAxios'
import Role from './Role'
import * as R from 'ramda'
import usePermission from 'hooks/usePermission'
import constants from 'config/constants'

const RoleContainer = () => {
  const { hasPermission } = usePermission()
  const hasManageRolePermission = hasPermission(constants.permissions.manageRoles)

  const { data: rolesData, loading: rolesDataLoading } = useAxios({
    method: 'get',
    url: 'account/roles/',
  })

  const { data: enabledCustomRole, loading: checkingEnabledCustomRole } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'custom_roles' },
  })
  const isEnabledCustomRoles = R.path(['enabled'], enabledCustomRole)

  return (
    <Role
      roles={rolesData}
      rolesDataLoading={rolesDataLoading}
      hasManageRolePermission={hasManageRolePermission}
      isEnabledCustomRoles={isEnabledCustomRoles}
      checkingEnabledCustomRole={checkingEnabledCustomRole}
    />
  )
}

export default RoleContainer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Roles/container.js